import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const StaticHero = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const heroData = [
    {
      src: '/img/heroimg1.jpeg',
      alt: '',
      captionText: 'Empower Your Business with Innovative Software Solutions',
      captionTitle: 'Best IT Solutions',
      captionbottom:
        'We are innovative, trustworthy, reliable, consumer focused, motivated, and creative.',
    },
    {
      src: '/img/carousel-1.jpg',
      alt: '',
      captionText: 'Quality Digital Services You Really Need!',
      captionTitle: 'Transforming Industries through Technology',
      captionbottom:
        'To push technologies beyond the expected and achieve a new extraordinary manifestation.',
    },
  ];

  return (
    <div className='animated  fadeInUp' style={{ animationDuration: '1.5s' }}>
      <div className='container-fluid px-0'>
        <div id='carouselId' className='carousel slide' data-bs-ride='carousel'>
          <ol className='carousel-indicators'>
            {heroData?.map((image, index) => (
              <li
                key={index}
                data-bs-target='#carouselId'
                data-bs-slide-to={index}
                className={index === 0 ? 'active' : ''}
                aria-current={index === 0 ? 'true' : undefined}
                aria-label={`Slide ${index + 1}`}
              ></li>
            ))}
          </ol>
          <div className='carousel-inner' role='listbox'>
            {heroData?.map((image, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 ? 'active' : ''}`}
              >
                <img
                  src={image.src}
                  className='img-fluid d-block w-100'
                  alt={image.alt}
                />
                <div className='carousel-caption'>
                  <div className='container carousel-content'>
                    <h6 className='txt-primary h4 animated fadeInUp'>
                      {image.captionTitle}
                    </h6>
                    <h1 className='text-white display-1 mb-4 animated fadeInRight'>
                      {image.captionText}
                    </h1>
                    <p className='mb-4 text-white fs-5 animated fadeInDown'>
                      {image.captionbottom}
                    </p>
                    <div className='d-flex justify-content-center'>
                      <Link to='/' className='ms-2'>
                        <button
                          type='button'
                          className='px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn1 animated fadeInLeft'
                        >
                          {t(`Read More`, { ns: 'components_header_trn' })}
                        </button>
                      </Link>
                      <Link to='/contact' className='ms-2'>
                        <button
                          type='button'
                          className='px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn2 animated fadeInRight'
                        >
                          {t(`Contact Us`, { ns: 'components_header_trn' })}
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button
            className='carousel-control-prev'
            type='button'
            data-bs-target='#carouselId'
            data-bs-slide='prev'
          >
            <span
              className='carousel-control-prev-icon'
              aria-hidden='true'
            ></span>
            <span className='visually-hidden'>Previous</span>
          </button>
          <button
            className='carousel-control-next'
            type='button'
            data-bs-target='#carouselId'
            data-bs-slide='next'
          >
            <span
              className='carousel-control-next-icon'
              aria-hidden='true'
            ></span>
            <span className='visually-hidden'>Next</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StaticHero;
